import { render, staticRenderFns } from "./CompaniesQR.vue?vue&type=template&id=1a620c6a&scoped=true&"
import script from "./CompaniesQR.vue?vue&type=script&lang=js&"
export * from "./CompaniesQR.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesQR.vue?vue&type=style&index=0&id=1a620c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a620c6a",
  null
  
)

export default component.exports